import { GroupChannel, Member } from '@sendbird/chat/groupChannel';
import { useChannelSettingsContext } from '@sendbird/uikit-react/ChannelSettings/context';
import { keepPreviousData, useQuery } from '@tanstack/react-query';

const fetchChannelMembers = async (
  channel: GroupChannel | null,
  onProgress?: (fetched: number, total: number) => void
) => {
  if (!channel) return [];

  const memberListQuery = channel.createMemberListQuery({
    limit: 100,
  });

  let allMembers: Member[] = [];
  while (memberListQuery.hasNext) {
    const members = await memberListQuery.next();
    allMembers = [...allMembers, ...members];

    if (onProgress) {
      onProgress(allMembers.length, channel.memberCount);
    }
  }

  return allMembers;
};

export const useFetchChannelMembers = (
  onProgress?: (fetched: number, total: number) => void
) => {
  const { channel } = useChannelSettingsContext();

  return useQuery<Member[]>({
    queryKey: ['channel-members', channel],
    queryFn: () => fetchChannelMembers(channel, onProgress),
    placeholderData: keepPreviousData,
    // Not sure if this will need to be revalidated when the member list changes (such as after an invite)
    staleTime: 60 * 1000, // 1 minute
  });
};
